import React, { useState } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddbBlogform.css";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateCareerDetails = ({ isEditing }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    jobTitle: "",
    companyName: "",
    location: "",
    jobType: [],
    experience: "",
    department: "",
    shiftTime: "",
    workingDays: "",
    vacancy: "",
    jobDescription: "",
    salary: "",
    benefits: "",
    departmentNotes: "",
  });

  const [alert, setAlert] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        jobType: checked
          ? [...prevData.jobType, value]
          : prevData.jobType.filter((job) => job !== value),
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      jobType: formData.jobType.join(", "),
    };

    try {
      await axios.post(`${CONFIG.BASE_URL}/career/add`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Career Added successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Ensure navigation happens after the toast is shown
      setTimeout(() => {
        navigate("/create-careers");
      }, 3000);
    } catch (error) {
      toast.error("Error adding career", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="modal-overlay  admin_modal_preview create_career_details">
      <div className="custom-modal-content">
        <div className="col-md-12 p-3 custom-modal-title text-center">
          <ToastContainer />
          <h2 className="mt-0" style={{ color: "white" }}>
            {isEditing ? "Edit Event" : "Create Job Opening"}
          </h2>
        </div>
        {alert && (
          <CustomAlert
            message={alert.message}
            onClose={() => setAlert(null)}
            type={alert.type}
          />
        )}

        <form id="jobApplicationForm" onSubmit={handleSubmit}>
          {/* Job Type */}
          <div className="form-group_wrap custom-align col-md-12">
            <div className="form-group filed_title col-md-4">
              <h5 className="text-left">Job Type</h5>
            </div>
            <div className="form-group job_type_wrap col-md-8">
              <div className="form-group job_type d-inline-flex">
                {[
                  "Onsite",
                  "Full Time",
                  "Part Time",
                  "Remote",
                  "Internship",
                ].map((type) => (
                  <div key={type} className="p-2 d-flex">
                    <input
                      type="checkbox"
                      name="jobType"
                      value={type}
                      checked={formData.jobType.includes(type)}
                      onChange={handleChange}
                    />
                    <label>{type}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Department */}
          <div className="form-group col-md-6">
            <label>Department: </label>
            <input
              type="text"
              className="form-control border-1"
              name="department"
              required
              value={formData.department}
              onChange={handleChange}
            />
          </div>

          {/* Job Title */}
          <div className="form-group col-md-6">
            <label>Job Title: </label>
            <input
              type="text"
              className="form-control border-1"
              name="jobTitle"
              required
              value={formData.jobTitle}
              onChange={handleChange}
            />
          </div>

          {/* Salary Range */}
          <div className="form-group col-md-6">
            <label>Salary Range: </label>
            <input
              type="text"
              className="form-control border-1"
              name="salary"
              required
              value={formData.salary}
              onChange={handleChange}
            />
          </div>

          {/* Experience */}
          <div className="form-group col-md-6">
            <label>Expected Experience: </label>
            <input
              type="text"
              className="form-control border-1"
              name="experience"
              required
              value={formData.experience}
              onChange={handleChange}
            />
          </div>

          {/* Shift Timing (Dropdown) */}
          <div className="form-group col-md-6">
            <label>Shift Time:</label>
            <select
              className="form-control border-1"
              name="shiftTime"
              required
              value={formData.shiftTime}
              onChange={handleChange}
            >
              <option value="">Select Shift Timing</option>
              <option value="9:30am to 6:30pm">9:30am to 6:30pm</option>
              <option value="2:00pm to 11:00pm">2:00pm to 11:00pm</option>
              <option value="8:00pm to 5:00am">8:00pm to 5:00am</option>
            </select>
          </div>

          {/* Working Days */}
          <div className="form-group col-md-6">
            <label>Working Days:</label>
            <input
              type="text"
              className="form-control border-1"
              name="workingDays"
              required
              value={formData.workingDays}
              onChange={handleChange}
            />
          </div>

          {/* Job Description */}
          <div className="form-group col-md-12">
            <label>Job Description:(Min-10 letters) </label>
            <textarea
              className="col-md-8 form-control border-1"
              name="jobDescription"
              rows="4"
              value={formData.jobDescription}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* Company Details */}
          <div className="form-group_wrap col-md-12">
            <div className="form-group filed_title col-md-4">
              <h5>Company Details</h5>
            </div>
          </div>

          {/* Company Selection (Dropdown) */}
          <div className="form-group col-md-6">
            <label>Company Name:</label>
            <select
              className="form-control border-1"
              name="companyName"
              required
              value={formData.companyName}
              onChange={handleChange}
            >
              <option value="">Select Company</option>
              <option value="KTNL">KTNL</option>
              <option value="KTMC">KTMC</option>
              <option value="BR Academy">BR Academy</option>
              <option value="BNR Cogniitec">BNR Cogniitec</option>
            </select>
          </div>

          {/* No. of Vacancies (Text Input) */}
          <div className="form-group col-md-6">
            <label>Vacancy:</label>
            <input
              type="text"
              className="form-control border-1"
              name="vacancy"
              required
              value={formData.vacancy}
              onChange={handleChange}
            />
          </div>

          {/* Job Location */}
          <div className="form-group col-md-6">
            <label>Location:</label>
            <input
              type="text"
              className="form-control border-1"
              name="location"
              required
              value={formData.location}
              onChange={handleChange}
            />
          </div>

          {/* Perks and Benefits */}
          <div class="form-group p-0 col-md-12">
            <div className="form-group col-md-6">
              <label>Benefits:(Min-10 letters)</label>
              <textarea
                className="col-md-12 form-control border-1"
                name="benefits"
                rows="4"
                value={formData.benefits}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Department Notes */}
            <div className="form-group col-md-6">
              <label>Department Notes:(Min-10 letters)</label>
              <textarea
                className="col-md-12 form-control border-1"
                name="departmentNotes"
                rows="4"
                value={formData.departmentNotes}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          {/* Submit Button */}
          <div className="col-md-12 p-3 job_createion_cta text-right">
            <button
              type="button"
              className=" custom-btn-cancel"
              onClick={() => navigate("/create-careers")}
            >
              Cancel
            </button>
            <button type="submit" className="custom-btn-submit">
              Create Job
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCareerDetails;
